<template>
  <div>
    <div style="width: 70%;margin: 0 15%;">
      <el-image :src="require('@/assets/img/gh_95f2062610c3_860.jpeg')" fit="fill" :width="100" :height="100"
        :lazy="true"></el-image>

      <el-card shadow="always" :body-style="{ padding: '20px' }">
        <div slot="header">
          <span>集思广益</span>
        </div>
        <el-form :model="addForm" ref="addForm" :rules="addFormRules" label-width="80px" :inline="false" size="normal">
          <el-form-item label="分类" prop="typeId">
            <el-select v-model="addForm.typeId" filterable placeholder="请选择分类">
              <el-option v-for="item in typeOptions"
                :key="item.id"
                :label="item.typeName"
                :value="item.id">
              </el-option>
            </el-select>
            
          </el-form-item>
          
          <el-form-item label="名称" prop="title">
            <el-input v-model="addForm.title"></el-input>
          </el-form-item>
          <el-form-item label="图片" prop="imgUrl">
            <image-uploader @update:fileList="handleUpdateFileList"></image-uploader>
          </el-form-item>
          <el-form-item label="评分" prop="rating">
            <el-rate style="padding-top: 10px" v-model="addForm.rating" :max="5"></el-rate>
          </el-form-item>
          <el-form-item label="简述" prop="recipesDescribe">
            <el-input v-model="addForm.recipesDescribe"></el-input>
          </el-form-item>
          <el-form-item  style="text-align: center;">
            <el-button :loading="btnLoading" :disabled="btnDisabled" type="primary" @click="handleSubmit">提交</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>




  </div>
</template>

<script>
import ImageUploader from "@/components/ImageUploader.vue";
import {save, page, listFoodType } from "@/api/recipes";
export default {
  name: "Recipes",
  components: {
    ImageUploader,
  },
  data() {
    return {
      btnLoading: false,
      btnDisabled: false,
      queryForm: {
        current: 1,
        pageSize: 10,
      },
      total: 0,
      recipesList: [],
      texts: ["不辣", "微微辣", "微辣", "中辣", "特辣", "变态辣"],
      previewImgList: [],
      typeOptions:[],
      addForm: {
        typeId: "",
        title: "",
        rating: 5,
        imgUrl: "",
        recipesDescribe: "",
      },
      addFormRules: {
        typeId:[
        { required: true, message: "请输入分类", trigger: "blur" },
        ],
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
        ],
      }
    };
  },
  created() {
    this.listFoodType();
  },
  methods: {
    handleSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          this.btnDisabled = true;
          console.log(this.addForm);
          save(this.addForm).then((res) => {
            if (res.code == 200) {
              this.$message.success("添加成功");
              this.$refs.addForm.resetFields();
              this.previewImgList = [];
              this.addForm.imgUrl = "";
            }
          }).catch((e) => {
            console.error(e);
          }).finally(() => {
            this.btnLoading = false;
            this.btnDisabled = false;
          });
        }
      }); 
    },
    listFoodType(){
      listFoodType().then((res)=>{
        if(res.code == 200){
          this.typeOptions = res.data;
          this.typeOptions = this.typeOptions.filter((item)=>{
            return item.typeName != "全部";
          })
        }
      })
    },
    pageRecipes() {
      page(this.queryForm).then((res) => {
        this.recipesList = res.data.records;
        this.total = res.data.total;
      });
    },
    handleSizeChange(newSize) {
      this.queryForm.pageSize = newSize;
      this.pageRecipes();
    },
    handleCurrentChange(newPage) {
      this.queryForm.current = newPage;
      this.pageRecipes();
    },
    handleClickImg(imgUrl) {
      this.previewImgList.push(imgUrl);
    },
    handleUpdateFileList(uploadedImageUrls) {
      this.addForm.imgUrl = uploadedImageUrls[0];
    },
  },
};
</script>


<style>
.clamped-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  /* 显示的行数 */
  overflow: hidden;
  text-overflow: ellipsis;
  height: calc(1.2em * 1);
  /* 行高乘以行数 */
  line-height: 1.2em;
  /* 根据需要调整行高 */
  max-height: calc(1.2em * 1);
  /* 确保最大高度 */
}
</style>